/**
 * Created by Kieran on 13/10/2017.
 * Code reducing method, to save code duplication
 */

//Date of birth data structure
import DobObject from './DateOfBirth'

const Objects = {
  DobObject: DobObject
};

export default Objects;



// WEBPACK FOOTER //
// ./src/helpers/Utilities/Objects/index.js